export enum SlTpValuesEnum {
	PERCENT = 'percent',
	PRICE = 'price',
	DOLLAR = 'dollar',
}
